<script>
   /*************************************************************/
   /* Widget for scaling                                        */
   /* -----------------------------------                       */
   /*************************************************************/

   import { Container, Select } from 'svelte-controls-basic';
   import PrepTemplate from './PrepTemplate.svelte';

   let {
      params = $bindable([1, 0]),
      settings = $bindable(),
      ...others
   } = $props();

   // prefix for the label ids the controls below are named by, unique per widget instance
   const uid = $props.id();

   // type to num maps
   const centerMap = {'no': 0, 'mean': 1, 'median': 2};
   const scaleMap = {'no': 0, 'sd': 1, 'iqr': 2, 'range': 3, 'pareto': 4};
   const centers = Object.keys(centerMap);
   const scales = Object.keys(scaleMap);

   // the options shown are the parameters read back through the maps; the controls write the
   // parameters directly, so there is no copy of them to keep in step
   const center = $derived(centers[params[0]]);
   const scale = $derived(scales[params[1]]);
   const title = 'Scaling';

   $effect(() => {
      settings = center + '/' + scale;
   });
</script>


<PrepTemplate {title} {settings} {...others}>
   <Container label="Center" id="{uid}-center">
   <Select bind:value={() => center, v => params[0] = centerMap[v]} options={centers} />
   </Container>
   <Container label="Scale" id="{uid}-scale">
   <Select bind:value={() => scale, v => params[1] = scaleMap[v]} options={scales} />
   </Container>
</PrepTemplate>

